'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.secondsFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/secondsFromNow.js
// module id = 276
// module chunks = 1